import { useLotCountdown } from "../hooks/useLotCountdown";

/**
 * A lot's countdown as "mm:ss" (#191): a Live lot's deadline counting down, or a Paused lot's time
 * frozen. Nothing at all when neither is known.
 *
 * Declared at module level on purpose: the boards rebuild their columns on every render, and a
 * component type created inside one would remount - and restart its timer - each time. It re-renders
 * only itself, once per displayed second, and never changes a row's status: the server decides when
 * a lot closes.
 *
 * @param {{endsAt?: number|null, frozenSeconds?: number|null}} props The lot's clock entry fields.
 * @returns {JSX.Element|null}
 */
const LotCountdown = ({ endsAt = null, frozenSeconds = null }) => {
  const { text } = useLotCountdown(endsAt, frozenSeconds);

  if (!Number.isFinite(endsAt) && !Number.isFinite(frozenSeconds)) return null;
  return <>{text}</>;
};

export default LotCountdown;
